import I18n from 'I18n';
const formatLocationValue = location => {
  if (location.type === 'PAGE') {
    return I18n.text('chatspotComponents.sections.sourcesListSectionFormatter.pageLocation', {
      pageNumber: location.value
    });
  }
  return location.value;
};
export const getLocationWithinDocument = source => {
  if ('locationWithinSource' in source && source.locationWithinSource) {
    return formatLocationValue(source.locationWithinSource);
  }
  if ('data' in source && source.data && 'locationWithinSource' in source.data && source.data.locationWithinSource) {
    return formatLocationValue(source.data.locationWithinSource);
  }
  return undefined;
};